import { AnimaAuth } from '../auth';
import { AnimaSettings } from '../settings';
import { AnimaUser } from '../user';

export type EnforceAuthParams = {
  user: AnimaUser;
  settings: AnimaSettings;
  auth: AnimaAuth;
};

export async function enforceAuthIfRequired(params: EnforceAuthParams): Promise<void> {
  try {
    const settings = await params.settings.getSettings();

    if (settings.requireAuth) {
      const currentUser = await params.user.me();

      if (currentUser === null) {
        // Auth required by user settings, but user is not logged in
        await params.auth.login();
      }
    }
  } catch (error) {
    console.error('Error enforcing auth:', error);
  }
}
